import { jsx } from "react/jsx-runtime";
import { Box, Button, CircularProgress } from "@mui/material";
import { forwardRef } from "react";
import { useFormMeta } from "../../../core/hooks/useFormMeta.js";
const FormActionButton = forwardRef(
  function FormActionButton2(props, ref) {
    const {
      label,
      testId = "form-action-button-root",
      color = "primary",
      variant = "text",
      ignoreFormDisabled,
      type = "button",
      loading,
      loaderColor = "primary",
      ...buttonProps
    } = props;
    const {
      meta: { disabled: formDisabled }
    } = useFormMeta();
    const disableButton = ignoreFormDisabled ? false : formDisabled;
    return /* @__PURE__ */ jsx(
      Button,
      {
        size: "small",
        disabled: disableButton,
        ...buttonProps,
        color,
        variant,
        "data-testid": testId,
        type,
        ref,
        children: loading ? /* @__PURE__ */ jsx(Box, { sx: { color: loaderColor, display: "flex" }, children: /* @__PURE__ */ jsx(CircularProgress, { size: 22, color: "inherit" }) }) : label
      }
    );
  }
);
export {
  FormActionButton
};
//# sourceMappingURL=FormActionButton.js.map
